/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
/**
 * CheckoutModulesStateShare Input Action
 */
export class BundleProductsStockStateShareInput implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `bunldeProductsSharedState`;
    public getCacheObjectType = () => 'bunldeProductsSharedState';
    public dataCacheType = (): CacheType => 'request';
}
// TODO: Create a data model here or import one to capture the response of the action
export interface IBundleProductsSharedState {
    areAllBundleProductsOOS?: boolean;
}
/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new BundleProductsStockStateShareInput();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function updateBundleProductsStockState(
    input: BundleProductsStockStateShareInput,
    ctx: IActionContext
): Promise<IBundleProductsSharedState> {
    return {
        areAllBundleProductsOOS: undefined
    };
}
/**
 * SampleState - create action
 */
export default createObservableDataAction<IBundleProductsSharedState>({
    action: <IAction<IBundleProductsSharedState>>updateBundleProductsStockState,
    input: createInput
});
